import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardContent/CardDetails/cardDetails.module.scss';
import { CardPillsAndIndicators } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardPillsAndIndicators/CardPillsAndIndicators';
import RichTextArea from 'components/common/richTextArea/richTextArea';
import { sortBy } from 'lodash';
import { userMentionMapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard.utils';
import Comments from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/comments/comments';
import { Control, Controller, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import SelectListWithCreate from 'components/common/selectListWithCreate/selectListWithCreate';
import { AssigneeAvatarWithInlineSelect } from 'components/common/AssigneeAvatarWithInlineSelect/AssigneeAvatarWithInlineSelect';
import { CustomizedTooltip } from 'components/common';
import SwitchComponent from 'components/common/Switch/Switch';
import { ProgramActivityRelatedActivityDates } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardContent/CardDetails/ProgramActivityRelatedActivityDates/ProgramActivityRelatedActivityDates';
import { AssociatedDocuments } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/AssociatedDocuments';
import { IFields } from 'components/common/CustomFilters/TableDateRangeFilter/TableDateRangeFilter';
import { QueryResponse as IBoardInitResponse } from 'api/queries/getBoardInitLite.query';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { IAssigneeWithExtraData } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCard/CreateCard.types';

interface Props {
    setValue: UseFormSetValue<IFields>;
    control: Control<IFields, IFields, IFields>;
    existingDetailsData: string | undefined;
    boardInit: IBoardInitResponse | undefined;
    handleDetails: (editorState, mentionedList) => void; // FIX TYPES OF THE ARGUMENTS
    data: CardResponse;
    queryKeys: string[];
    register: UseFormRegister<IFields>;
    errors: FieldErrors<IFields>;
    tagsOptions: { label: string; value: string }[];
    watch: UseFormWatch<IFields>;
    submittedDurationComplete: string | number;
    assigneeValue: IAssigneeWithExtraData | null;
    handleAssigneeSelect: (value) => void;
}

export const CardDetailsDesktop = ({
    data,
    watch,
    submittedDurationComplete,
    handleDetails,
    existingDetailsData,
    boardInit,
    queryKeys,
    tagsOptions,
    control,
    setValue,
    register,
    errors,
    assigneeValue,
    handleAssigneeSelect,
}: Props) => {
    return (
        <div className={classes.cardDetailsContainer}>
            <div className={classes.leftSection}>
                <CardPillsAndIndicators
                    data={data}
                    watch={watch}
                    submittedDurationComplete={submittedDurationComplete}
                />

                <div data-track-id={`text-editor-card`}>
                    <div className={classes.title}>Details:</div>
                    <RichTextArea
                        onEditorDescription={handleDetails}
                        existingData={existingDetailsData}
                        editorContentHeight={140}
                        mention={{
                            separator: ' ',
                            trigger: '@',
                            suggestions: sortBy(boardInit?.assignee.map(userMentionMapper), 'text') || [],
                        }}
                        id={'cardModalDetails'}
                        placeholder={
                            'Enter here activity narrative, mitigation, or risk details. \nType @ to mention another user and notify them about it.'
                        }
                    />
                </div>

                <Comments
                    id={data.id}
                    isVirtual={data?.isVirtual}
                    card={data}
                    assigneeOptions={sortBy(boardInit?.assignee.map(userMentionMapper), 'text') || []}
                    queryKeys={queryKeys}
                />
            </div>

            <div className={classes.rightSection}>
                <div className={classes.selectWrapper} data-track-id={`tags-select-card`}>
                    <div className={classes.title}>Tags:</div>
                    <div className={classes.content}>
                        <Controller
                            render={({ field }) => (
                                <SelectListWithCreate {...field} options={tagsOptions} id={'cardModalTags'} />
                            )}
                            name={`tagList`}
                            control={control}
                        />
                    </div>
                </div>

                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Assignee *:</div>
                    <div className={classes.content}>
                        <div className={classes.inlineSelectWrapper}>
                            <Controller
                                render={({ field }) => (
                                    <AssigneeAvatarWithInlineSelect
                                        {...field}
                                        assigneeValue={assigneeValue}
                                        onSelection={handleAssigneeSelect}
                                    />
                                )}
                                name={`assignee`}
                                control={control}
                                rules={{
                                    required: 'Assignee is Required',
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Important:</div>
                    <div className={classes.content}>
                        <CustomizedTooltip
                            triggerElement={
                                <Controller
                                    render={({ field }) => (
                                        <SwitchComponent checked={field.value} onChange={field.onChange} />
                                    )}
                                    name={`isImportant`}
                                    control={control}
                                />
                            }
                            tooltipContent={'This setting effects Priority Matrix'}
                        />
                    </div>
                </div>

                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Category *:</div>
                    <div data-testid={'category-content'} className={classes.content}>
                        {watch('category')?.label}
                    </div>
                </div>

                <ProgramActivityRelatedActivityDates
                    data={data}
                    setValue={setValue}
                    control={control}
                    watch={watch}
                    register={register}
                    errors={errors}
                />
                <AssociatedDocuments watch={watch} setValue={setValue} />
            </div>
        </div>
    );
};
